import Modal, {SimpleModalControls} from "../../../components/Modal";
import { useTranslation } from "react-i18next";

interface ItemsWithNoPriceNotificationProps extends SimpleModalControls {
    items: { name: string, id: string }[]
}

const ItemsWithNoPriceNotification = (props: ItemsWithNoPriceNotificationProps) => {
    const {
        isOpen,
        onClose,
        items
    } = props;

    const { t } = useTranslation();

    return (
       <Modal
           size={"4xl"}
           header={t("ITEMS_WITH_NO_PRICE_TRANSFER_NOTIFICATION")}
           isOpen={isOpen}
           onClose={onClose}
       >
           <div>
               <div className="text-2xl text-red-500">Transferul nu poate fi initiat deoarece contine produse ce nu au
                   pret de vanzare!
               </div>
               <div className="text-xl text-red-500 mt-4">Dupa adaugarea pretului de vanzare recreaza transferul!
                   Inchiderea modalului de notificare va inchide si transferul completat
               </div>
               <div className="mt-4">
                   <div className="text-xl underline underline-offset-4 text-red-500 mb-4">Produsele fara pret de vanzare:</div>
                   {items.map((item, index) => <div key={`product_with_no_price_${index}`}
                                                    className="mt-2 text-lg text-white bg-amber-400 hover:bg-amber-300 p-2 rounded">
                       <a target="_blank" rel="noopener noreferrer" href={"/product/" + item.id}>{item.name}</a>
                   </div>)}
               </div>
           </div>
       </Modal>
    )
}

export default ItemsWithNoPriceNotification;